import { createFileRoute } from '@tanstack/react-router';

import { BankUpdatesTab } from '@/features/deals';

export const Route = createFileRoute('/_app/deals/$dealId/bank-updates')({
  component: function Tab() {
    const { dealId } = Route.useParams();
    return <BankUpdatesTab dealId={dealId} />;
  },
});
